import {
    ContainerStyled,
    VerifyAccordionListStyled,
    VerifyComponentHeaderStyled,
    VerifyComponentStyled,
    VerifyComponentsWrapper,
    VerifyDescriptionStyled,
    VerifyDividerColStyled,
    VerifyDividerStyled,
    VerifyDocColStyled,
    VerifyDocIconStyled,
    VerifyFooterContainer,
    VerifyMiniatureDocColStyled,
    VerifyMiniatureDocContainer,
} from "./styled/VerifyStyled";
import { ParagraphStyled } from "../../components/typography/styled/TypographyStyled";
import { Accordion } from "react-bootstrap";
import { AccordionToggle } from "../../components/AccordionToggle/AccordionToggle";
import { DocumentCheckCard } from "./components/document-check-card/DocumentCheckCard";
import { ButtonArrow } from "../../components/button-arrow/ButtonArrow";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext";
import { memo, useCallback, useRef } from "react";
import { BinIcon } from "../../components/icon/Icon";
import { CardMiniature } from "./components/card-miniature/CardMiniature";
import { useGTMEvent } from "../GoogleTagManager/googleTagManagerHooks";

const DocIcon = memo(({name}) => (
    <VerifyDocIconStyled>
        <BinIcon name={name} style={{fontSize: '32px', fill: 'var(--color-yellow)'}}/>
    </VerifyDocIconStyled>
));

const SuccessCardMiniature = memo((props) => (
    <CardMiniature color="#CAD0E7" headColor="#40425D" bgColor="#CAD0E71A" {...props} />
));

const ErrorCardMiniature = memo((props) => (
    <CardMiniature color="#FF646C33" headColor="#4F3349" bgColor="#FF646C1A" {...props} />
));

function VerifyContent() {
    const {getLangPath} = useLangContext();
    const {handleGTMClick} = useGTMEvent();
    const accordionRef = useRef(null);
    const verificationEmail = getLangPath('verify.email');
    const emailTheme = getLangPath('email_theme');
    const mailToLink = `mailto:${verificationEmail}?subject=${emailTheme}`;

    const handleAccordionOpen = useCallback(() => {
        if (accordionRef.current) {
            setTimeout(() => accordionRef.current.scrollIntoView(), 100)
        }
        handleGTMClick({module: 'VerifyPage', button: 'HowToPrepareDocuments', action: 'Open'});
    }, [handleGTMClick]);

    const handleSendDocumentsClick = useCallback(() => handleGTMClick({
        module: 'VerifyPage',
        button: 'SendDocuments'
    }), [handleGTMClick]);

    const handleAccordionClose = useCallback(() => {
        handleGTMClick({module: 'VerifyPage', button: 'HowToPrepareDocuments', action: 'Close'});
    }, [handleGTMClick]);

    return <>
            <VerifyComponentsWrapper>
                <ContainerStyled>
                    <VerifyDocColStyled>
                        <VerifyComponentStyled>
                            <DocIcon name="IcPassport"/>
                            <VerifyComponentHeaderStyled>
                                {getLangPath('verify.title2')}
                            </VerifyComponentHeaderStyled>
                            <ParagraphStyled>{getLangPath('verify.text2')}</ParagraphStyled>
                        </VerifyComponentStyled>
                    </VerifyDocColStyled>
                    <VerifyDividerColStyled>
                        <VerifyDividerStyled>&</VerifyDividerStyled>
                    </VerifyDividerColStyled>
                    <VerifyDocColStyled>
                        <VerifyComponentStyled>
                            <DocIcon name="IcBankCard"/>
                            <VerifyComponentHeaderStyled>
                                {getLangPath('verify.title3')}
                            </VerifyComponentHeaderStyled>
                            <ParagraphStyled>{getLangPath('verify.text3')}</ParagraphStyled>
                        </VerifyComponentStyled>
                    </VerifyDocColStyled>
                    <VerifyDividerColStyled>
                        <VerifyDividerStyled>or</VerifyDividerStyled>
                    </VerifyDividerColStyled>
                    <VerifyDocColStyled>
                        <VerifyComponentStyled>
                            <DocIcon name="IcWallet"/>
                            <DocIcon name="IcBank"/>
                            <VerifyComponentHeaderStyled>
                                {getLangPath('verify.title4')}
                            </VerifyComponentHeaderStyled>
                            <ParagraphStyled>{getLangPath('verify.text4')}</ParagraphStyled>
                        </VerifyComponentStyled>
                    </VerifyDocColStyled>
                </ContainerStyled>
            </VerifyComponentsWrapper>
            <Accordion>
                <Accordion.Item eventKey={0}>
                    <AccordionToggle
                        eventKey={0}
                        onClose={handleAccordionClose}
                        onOpen={handleAccordionOpen}
                    >
                        {getLangPath('verify.title_prepare')}
                    </AccordionToggle>
                    <Accordion.Body ref={accordionRef}>
                        <VerifyAccordionListStyled>
                            <li>
                                <VerifyDescriptionStyled>
                                    {getLangPath('verify.text_prepare1')}
                                </VerifyDescriptionStyled>
                            </li>
                            <li>
                                <div className="mb-md-3 mb-2">
                                    <VerifyDescriptionStyled>
                                        {getLangPath('verify.text_prepare2')}
                                    </VerifyDescriptionStyled>
                                </div>
                                <VerifyMiniatureDocContainer>
                                    <VerifyMiniatureDocColStyled>
                                        <DocumentCheckCard>
                                            <SuccessCardMiniature
                                                fontSize="4px"
                                                style={{top: '10px', left: '10px'}}
                                            />
                                        </DocumentCheckCard>
                                    </VerifyMiniatureDocColStyled>
                                    <VerifyMiniatureDocColStyled>
                                        <DocumentCheckCard error>
                                            <ErrorCardMiniature
                                                fontSize="6px"
                                                style={{top: '-35px', left: '18px'}}
                                            />
                                        </DocumentCheckCard>
                                    </VerifyMiniatureDocColStyled>
                                    <VerifyMiniatureDocColStyled>
                                        <DocumentCheckCard error>
                                            <ErrorCardMiniature
                                                fontSize="2px"
                                                style={{top: '30px', left: '70px'}}
                                            />
                                        </DocumentCheckCard>
                                    </VerifyMiniatureDocColStyled>
                                </VerifyMiniatureDocContainer>
                            </li>
                            <li>
                                <VerifyDescriptionStyled>
                                    {getLangPath('verify.text_prepare3')}
                                </VerifyDescriptionStyled>
                            </li>
                        </VerifyAccordionListStyled>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <VerifyFooterContainer>
                <ButtonArrow as="a" href={mailToLink} onClick={handleSendDocumentsClick}>
                    {getLangPath('verify.button')}
                </ButtonArrow>
                <VerifyDescriptionStyled className="mt-3">
                    {getLangPath('verify.button_description')}
                </VerifyDescriptionStyled>
            </VerifyFooterContainer>
    </>
}

export default VerifyContent;
